import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pricing from "../pages/Pricing";
import TapnPage from "../pages/tapn/page";
import Contact from "../pages/Contact";
import Blog from "../pages/Blog";
import Signup from "../pages/Signup";
import Success from "../pages/Success";
import Status from "../pages/Status";

// Admin
import Login from "../pages/admin/Login";
import LeadsList from "../pages/admin/LeadsList";
import LeadDetail from "../pages/admin/LeadDetail";
import { ProtectedRoute } from "../components/admin/ProtectedRoute";

// Products
import Payments from "../pages/products/Payments";
import Subscriptions from "../pages/products/Subscriptions";
import Connect from "../pages/products/Connect";
import Radar from "../pages/products/Radar";
import Billing from "../pages/products/Billing";
import Terminal from "../pages/products/Terminal";

// Developers
import Docs from "../pages/developers/Docs";
import SDK from "../pages/developers/SDK";
import Webhooks from "../pages/developers/Webhooks";

// Resources
import CaseStudies from "../pages/resources/CaseStudies";
import Guides from "../pages/resources/Guides";
import Partners from "../pages/resources/Partners";

// Legal
import Privacy from "../pages/legal/Privacy";
import Terms from "../pages/legal/Terms";
import Security from "../pages/legal/Security";
import Cookies from "../pages/legal/Cookies";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/tapn", element: <TapnPage /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/contact", element: <Contact /> },
  { path: "/blog", element: <Blog /> },
  { path: "/signup", element: <Signup /> },
  { path: "/success", element: <Success /> },
  { path: "/status", element: <Status /> },
  
  // Admin
  { path: "/admin/login", element: <Login /> },
  { path: "/admin/leads", element: <ProtectedRoute><LeadsList /></ProtectedRoute> },
  { path: "/admin/leads/:email", element: <ProtectedRoute><LeadDetail /></ProtectedRoute> },
  
  // Products
  { path: "/products/payments", element: <Payments /> },
  { path: "/products/subscriptions", element: <Subscriptions /> },
  { path: "/products/connect", element: <Connect /> },
  { path: "/products/radar", element: <Radar /> },
  { path: "/products/billing", element: <Billing /> },
  { path: "/products/terminal", element: <Terminal /> },
  
  // Developers
  { path: "/developers/docs", element: <Docs /> },
  { path: "/developers/sdk", element: <SDK /> },
  { path: "/developers/webhooks", element: <Webhooks /> },
  
  // Resources
  { path: "/resources/case-studies", element: <CaseStudies /> },
  { path: "/resources/guides", element: <Guides /> },
  { path: "/resources/partners", element: <Partners /> },

  // Legal
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "/security", element: <Security /> },
  { path: "/cookies", element: <Cookies /> },

  // Catch-all
  { path: "*", element: <NotFound /> },
];

export default routes;
